var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAgritourism = function SvgAgritourism(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.822,
    height: 20.673
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#102b3f",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3586",
    d: "m13.648 11 7.081-7.081L27.81 11",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3587",
    d: "M1.495 19.347s8.507-2.295 15.257-2.295a30.849 30.849 0 0 1 11.743 2.295"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3588",
    d: "M1.266 13.861a21.333 21.333 0 0 1 6.877-.986 33.731 33.731 0 0 1 6.815 1.189"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 375",
    d: "M6.766 15.014v-5"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 482",
    transform: "translate(2.266)",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.5,
    cy: 5.5,
    rx: 4.5,
    ry: 5.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.5,
    cy: 5.5,
    rx: 3.5,
    ry: 4.5
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 378",
    d: "M15.745 12.2v4.627"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 379",
    d: "M25.745 12.2v5.627"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8921",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 339",
    d: "M19.604 16.36v-3"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 340",
    d: "M21.854 13.36h-2.25"
  })))));
};
export default SvgAgritourism;